import {gsap} from 'gsap'

import {ScrollSmoother} from 'gsap/ScrollSmoother'
import {ScrollTrigger} from 'gsap/ScrollTrigger'
import {SplitText} from 'gsap/SplitText'

gsap.registerPlugin(ScrollSmoother, ScrollTrigger, SplitText)

export default class Animations {
  initialize() {
    console.debug('== Animations components ==')

    // Smooth scroller
    let smoother = ScrollSmoother.create({
      wrapper: '#smooth-wrapper',
      content: '#smooth-content',
      smooth: 1,
      smoothTouch: 0.1,
      effects: true,
    })

    // let smoother

    const mainWrapper = document.querySelector('.main-wrapper')

    this.componentScrollAnimation(smoother)

    if (mainWrapper.classList.contains('home-page')) {
      this.sectionHeroHomeAnimation()
    } else {
      this.sectionHeaderProjectAnimation()
    }

    // this.headerLogoAnimation()
    this.sectionBottleAnimation()
    this.sectionNumberAnimation()
    this.sectionChallangeAnimation()
    this.sectionSuggestedNewsAnimation()
    this.sectionMoreAnimation()

    this.generalAnimations()
  }

  generalAnimations() {
    // General animations
    console.debug('  -> Animate general components')

    const animateFadeIn = document.querySelectorAll('.animate-fade-in')

    animateFadeIn.forEach((item) => {
      let tl = gsap.timeline({paused: true})

      tl.from(item, {
        autoAlpha: 0,
        duration: 1,
        ease: 'expo.out',
      })

      ScrollTrigger.create({
        trigger: item,
        start: 'top 75%',
        end: 'bottom 90%',
        animation: tl,
        markers: false,
        toggleActions: 'play none none reverse',
      })
    })

    const animateFadeInEarly = document.querySelectorAll(
      '.animate-fade-in-early'
    )

    animateFadeInEarly.forEach((item) => {
      let tl = gsap.timeline({paused: true})

      tl.from(item, {
        autoAlpha: 0,
        duration: 1,
        ease: 'expo.out',
      })

      ScrollTrigger.create({
        trigger: item,
        start: 'top 95%',
        end: 'bottom 90%',
        animation: tl,
        markers: false,
        toggleActions: 'play none none reverse',
      })
    })

    const animateSlideIn = document.querySelectorAll('.animate-slide-in')
    const animateSplitSlideIn = []

    animateSlideIn.forEach((elem) => {
      const splitElem = new SplitText(elem, {
        type: 'words,lines',
        linesClass: 'line-split-text',
      })

      animateSplitSlideIn.push(splitElem)
    })

    animateSplitSlideIn.forEach((item, index) => {
      let tl = gsap.timeline({paused: true})

      tl.from(item.words, {
        duration: 0.5,
        ease: 'expo.out',
        y: 130,
        stagger: 0.175,
      })

      ScrollTrigger.create({
        trigger: animateSlideIn[index],
        start: 'top 75%',
        end: 'bottom 90%',
        animation: tl,
        markers: false,
        toggleActions: 'play none none reverse',
      })
    })

    const animateSlideInEarly = document.querySelectorAll(
      '.animate-slide-in-early'
    )
    const animateSplitSlideInEarly = []

    animateSlideInEarly.forEach((elem) => {
      const splitElem = new SplitText(elem, {
        type: 'words,lines',
        linesClass: 'line-split-text',
      })

      animateSplitSlideInEarly.push(splitElem)
    })

    animateSplitSlideInEarly.forEach((item, index) => {
      let tl = gsap.timeline({paused: true})

      tl.from(item.words, {
        duration: 0.5,
        ease: 'expo.out',
        y: 130,
        stagger: 0.175,
      })

      ScrollTrigger.create({
        trigger: animateSlideInEarly[index],
        start: 'top 95%',
        end: 'bottom 90%',
        animation: tl,
        markers: false,
        toggleActions: 'play none none reverse',
      })
    })
  }

  // headerLogoAnimation() {
  //   // header logo animation

  //   const headerLogo = document.querySelector('#header-logo')

  //   if (headerLogo) {
  //     const logoLetters = Array.from(
  //       headerLogo.querySelectorAll('.letters-group path')
  //     )
  //     const logoSymbols = Array.from(
  //       headerLogo.querySelectorAll('.symbol-group path')
  //     )

  //     const tlLogo = gsap.timeline({paused: true})

  //     // tlLogo.to(logoLetters.reverse(), {
  //     //   duration: 0.5,
  //     //   ease: 'expo.out',
  //     //   opacity: 0,
  //     //   scale: 1.4,
  //     //   stagger: 0.175,
  //     //   transformOrigin: 'center center',
  //     // })

  //     tlLogo.to(logoLetters.reverse(), {
  //       duration: 0.5,
  //       ease: 'expo.out',
  //       opacity: 0,
  //       x: 20,
  //       stagger: 0.175,
  //       transformOrigin: 'center center',
  //     })

  //     window.addEventListener('scroll', (e) => {
  //       const heroOffset = 50
  //       const scrollTop =
  //         window.pageYOffset || document.documentElement.scrollTop

  //       if (scrollTop > heroOffset) {
  //         tlLogo.play()
  //       } else if (scrollTop <= heroOffset) {
  //         tlLogo.reverse()
  //       }
  //     })
  //   }
  // }

  sectionBottleAnimation() {
    // Bottle section load animation

    const sectionBottle = document.querySelector('.section--bottle')

    if (sectionBottle) {
      console.debug('  -> Animate bottle section')
      const bottleBgs = sectionBottle.querySelectorAll('.bottle-bg')
      const bottleTitle = sectionBottle.querySelector('.section-title')
      const bottleDescription = sectionBottle.querySelector(
        '.section-description'
      )

      const splitBottleTitle = new SplitText(bottleTitle, {
        type: 'words,lines',
        linesClass: 'line-split-text',
      })

      const splitBottleDescription = new SplitText(bottleDescription, {
        type: 'lines',
        linesClass: 'line-split-text',
      })

      gsap.set([bottleTitle, bottleDescription], {autoAlpha: 1})

      const tlBottle = gsap.timeline({paused: true})

      tlBottle
        .from(splitBottleTitle.words, {
          duration: 0.5,
          ease: 'expo.out',
          y: 130,
          stagger: 0.175,
          delay: 0,
        })
        .from(splitBottleDescription.lines, {
          duration: 0.5,
          ease: 'expo.out',
          y: 130,
          stagger: 0.25,
          delay: -0.25,
        })
        .from(bottleBgs, {
          autoAlpha: 0,
          duration: 1.75,
          ease: 'expo.out',
          delay: -1,
        })

      ScrollTrigger.create({
        trigger: bottleTitle,
        start: 'top 75%',
        end: 'bottom 90%',
        animation: tlBottle,
        markers: false,
        toggleActions: 'play none none none',
      })
    }
  }

  sectionNumberAnimation() {
    // Numbers section load animation

    const sectionNumbers = document.querySelector('.section--numbers')

    if (sectionNumbers) {
      console.debug('  -> Animate numbers section')

      const numbersTitle = sectionNumbers.querySelector('.section-title')
      const numbersCarousel = sectionNumbers.querySelector('.swiper--numbers')
      const numbersBg = sectionNumbers.querySelector('.section-bg')

      const splitNumbersTitle = new SplitText(numbersTitle, {
        type: 'words,lines',
        linesClass: 'line-split-text',
      })

      gsap.set([numbersTitle], {autoAlpha: 1})

      const tlNumbers = gsap.timeline({paused: false})

      tlNumbers
        .from(splitNumbersTitle.words, {
          duration: 0.5,
          ease: 'expo.out',
          y: 130,
          stagger: 0.175,
          delay: 0,
        })
        .from(numbersBg, {
          autoAlpha: 0,
          duration: 1.75,
          ease: 'expo.out',
          delay: -0.5,
        })
        .from(numbersCarousel, {
          autoAlpha: 0,
          duration: 1.75,
          ease: 'expo.out',
          delay: -1.25,
        })

      ScrollTrigger.create({
        trigger: numbersTitle,
        start: 'top 75%',
        end: 'bottom 90%',
        animation: tlNumbers,
        markers: false,
        toggleActions: 'play none none none',
      })
    }
  }

  sectionChallangeAnimation() {
    // Challange section load animation
    console.debug('  -> Animate challange section')

    const sectionChallange = document.querySelector('.section--challange')

    if (sectionChallange) {
      const challangeTitle = sectionChallange.querySelector('.section-title')

      const splitChallangeTitle = new SplitText(challangeTitle, {
        type: 'words,lines',
        linesClass: 'line-split-text',
      })

      gsap.set([challangeTitle], {autoAlpha: 1})

      const tlChallange = gsap.timeline({paused: false})

      tlChallange.from(splitChallangeTitle.words, {
        duration: 0.5,
        ease: 'expo.out',
        y: 165,
        stagger: 0.175,
        delay: 0,
      })

      ScrollTrigger.create({
        trigger: challangeTitle,
        start: 'top 75%',
        end: 'bottom 90%',
        animation: tlChallange,
        markers: false,
        toggleActions: 'play none none none',
      })
    }
  }

  sectionMoreAnimation() {
    const sectionMore = document.querySelector('.section--more')
    if (sectionMore) {
      console.debug('  -> Animate more section')

      const moreTitle = sectionMore.querySelector('.section-title')
      const moreCta = sectionMore.querySelector('.cta')
      const moreImg = sectionMore.querySelector('img')

      const splitMoreTitle = new SplitText(moreTitle, {
        type: 'words,lines',
        linesClass: 'line-split-text',
      })

      gsap.set([moreTitle, moreCta, moreImg], {autoAlpha: 1})

      const tlMore = gsap.timeline({paused: true})

      tlMore
        .from(splitMoreTitle.words, {
          duration: 0.5,
          ease: 'expo.out',
          y: 130,
          stagger: 0.175,
          delay: 0,
        })
        .from(moreCta, {
          autoAlpha: 0,
          duration: 0.75,
          ease: 'expo.out',
          delay: -0.25,
        })
        .from(moreImg, {
          autoAlpha: 0,
          duration: 1.5,
          x: 100,
          ease: 'expo.out',
          delay: -0.25,
        })

      ScrollTrigger.create({
        trigger: moreTitle,
        start: 'top 75%',
        end: 'bottom 90%',
        animation: tlMore,
        markers: false,
        toggleActions: 'play none none none',
      })
    }
  }

  sectionSuggestedNewsAnimation() {
    // News section load animation
    console.debug('  -> Animate news section')

    const sectionNews = document.querySelector('.section--news')

    if (sectionNews) {
      const newsTitle = sectionNews.querySelector('.section-title')
      const newsCta = sectionNews.querySelector('.section-cta')

      const splitNewsTitle = new SplitText(newsTitle, {
        type: 'words,lines',
        linesClass: 'line-split-text',
      })

      gsap.set([newsTitle], {autoAlpha: 1})

      const tlNews = gsap.timeline({paused: true})

      tlNews
        .from(splitNewsTitle.lines, {
          duration: 0.5,
          ease: 'expo.out',
          y: 130,
          delay: 0,
        })
        .from(newsCta, {
          autoAlpha: 0,
          duration: 1.5,
          ease: 'expo.out',
          delay: -0.25,
        })

      ScrollTrigger.create({
        trigger: newsTitle,
        start: 'top 75%',
        end: 'bottom 90%',
        animation: tlNews,
        markers: false,
        toggleActions: 'play none none none',
      })
    }
  }

  componentScrollAnimation(smoother) {
    // Scroll To - hero component
    const scrollMain = document.querySelector('.scroll-component')
    if (scrollMain) {
      scrollMain.addEventListener('click', () => {
        gsap.to(smoother, {
          scrollTop: smoother.offset(scrollMain.dataset.target) - 60,
          duration: 1.5,
          ease: 'power3.out',
        })
      })
    }
  }

  sectionHeroHomeAnimation() {
    const header = document.querySelector('.header')

    // Hero section load animation
    console.debug('  -> Animate hero section')

    const sectionHero = document.querySelector('.section--hero')
    if (sectionHero) {
      const heroBg = sectionHero.querySelector('.hero-background')
      const heroScroll = sectionHero.querySelector('.hero-scroll')
      const heroTitle = sectionHero.querySelector('.hero-title')
      const heroSubtitle = sectionHero.querySelector('.hero-subtitle')
      const heroDescription = sectionHero.querySelector('.hero-description')

      const splitHeroTitle = new SplitText(heroTitle, {
        type: 'words,lines',
        linesClass: 'line-split-text',
      })

      const splitHeroSubtitle = new SplitText(heroSubtitle, {
        type: 'lines',
        linesClass: 'line-split-text',
      })

      const splitHeroDescription = new SplitText(heroDescription, {
        type: 'words,lines',
        linesClass: 'line-split-text',
      })

      gsap.set([heroTitle, heroSubtitle], {autoAlpha: 1})

      const tlHero = gsap.timeline()

      tlHero
        .from(header, {
          autoAlpha: 0,
          duration: 1,
          ease: 'expo.out',
          delay: 0.25,
        })
        .from(splitHeroTitle.words, {
          duration: 0.5,
          ease: 'expo.out',
          y: 130,
          stagger: 0.175,
          delay: -0.5,
        })
        .from(splitHeroSubtitle.lines, {
          duration: 0.5,
          ease: 'expo.out',
          y: 130,
          stagger: 0.25,
          delay: -0.5,
        })
        .from(heroBg, {
          autoAlpha: 0,
          duration: 1.5,
          ease: 'expo.out',
          delay: -1.15,
        })
        .from(heroDescription, {
          autoAlpha: 0,
          duration: 1,
          ease: 'expo.out',
          delay: -0.25,
        })
        .from(splitHeroDescription.lines, {
          duration: 0.5,
          ease: 'expo.out',
          y: 130,
          stagger: 0.175,
          delay: -0.75,
        })
        .from(heroScroll, {
          autoAlpha: 0,
          duration: 0.5,
          ease: 'power3.out',
          delay: -0.25,
        })
    }
  }

  sectionHeaderProjectAnimation() {
    const header = document.querySelector('.header')

    // Hero section load animation
    console.debug('  -> Animate header section')

    const tlHero = gsap.timeline()

    tlHero.from(header, {
      autoAlpha: 0,
      duration: 1,
      ease: 'expo.out',
      delay: 0.25,
    })
  }

  static init() {
    const animationsInstance = new Animations()
    animationsInstance.initialize()
  }
}
